import { render, staticRenderFns } from "./UploadPic.vue?vue&type=template&id=4fba8840&"
import script from "./UploadPic.vue?vue&type=script&lang=js&"
export * from "./UploadPic.vue?vue&type=script&lang=js&"
import style0 from "./UploadPic.vue?vue&type=style&index=0&id=4fba8840&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports